import { useContext, useState } from "react";
import utility from "src/utils/utility";
import { useNavigate } from "react-router-dom";
import ApiContext from "src/provider/API/call-service";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import {
  FlexColumn,
  FlexRow,
  ScreenTitle,
  ScreenContainer,
  FormGroup,
  Button,
  AppSpan,
  Form,
} from "src/style";
import Logo from "src/assets/img/main-logo.jpg";
import "./index.scss";
import { AiOutlineUser } from "react-icons/ai";
import { HiLockClosed } from "react-icons/hi";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import helpers from "src/utils/helpers";

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const {notifier} = useContext(VisibilityContext)
  const { API } = useContext(ApiContext);
  const [input, setInput] = useState({ username: "", password: "" });
  const [passwordType, setPasswordType] = useState("password");

  function handleShow(type: string) {
    type === "password" ? setPasswordType("password") : setPasswordType("text");
  }

  async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
    e.preventDefault()
    const validation = helpers.inputValidator(input)
    if (!validation.isValidated) return notifier.show(validation.message, 'Validation Response')
    
    const response = await API.signin(input);
    if (response) navigate("/dashboard/home");
  }

  return (
    <ScreenContainer className="signIn">
      <div className="signIn__cover"></div>
      <FlexColumn className="signIn--flex">
        <div className="img__container">
          <img src={Logo} alt="logo" className="img" />
        </div>
        <ScreenTitle
          align="center"
          topMargin="2"
          width="34.6"
          fontWeight="500"
          bottomMargin="4"
        >
          Welcome Back, Kindly Login Here
        </ScreenTitle>
        <Form 
          onSubmit={handleSubmit} 
          style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}
        >
          <FormGroup width="40" topMargin="2" className="signIn__formGroup">
            <AiOutlineUser size={20} className="signIn__input--icon" />
            <input 
              type="text" placeholder="Username" 
              value={input.username}
              onChange={(e) => setInput({...input, username: e.target.value})}
              className="signIn__input" 
            />
          </FormGroup>

          <FormGroup width="40" className="input--password signIn__formGroup">
            <HiLockClosed size={20} className="signIn__input--icon" />
            <input
              type={passwordType}
              placeholder="Password"
              value={input.password}
              onChange={(e) => setInput({...input, password: e.target.value})}
              className="signIn__input input--password"
            />
            {passwordType === "password" ? (
              <FaEyeSlash
                className="signIn__show"
                onClick={() => handleShow("text")}
                size={20}
              />
            ) : (
              <FaEye
                className="signIn__show"
                onClick={() => handleShow("password")}
                size={20}
              />
            )}
          </FormGroup>
          <FormGroup width="40" className="signIn__formGroup">
            <Button
              radius="10"
              bgColor="#702126"
              color="#ffffff"
              className="signIn__btn"
              fontWeight="350"
              hoverBgColor="#A77B37"
            >
              Login
            </Button>
          </FormGroup>
        </Form>
        <FlexRow className="toggleContainer">
          <div className="toggle-switch">
            <input
              type="checkbox"
              className="checkbox"
              name="toggle"
              id="toggle"
            />

            <div className="inner"></div>
            <div className="switch"></div>
          </div>
          <AppSpan
            className="keep-log"
            leftMargin="2"
            fontWeight="350"
          >
            Keep Logged in
          </AppSpan>
        </FlexRow>
      </FlexColumn>
    </ScreenContainer>
  );
};

export default utility.routeData("signin", "SignIn", <SignIn />);
